export default __webpack_public_path__ + "static/media/Monk's Boots of the Limitless Cipher.aa4e4f55.jpg";